var React = require('react');

function Lightbluebox (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_57","data-name":"Path 57","d":"M0-382.312H480.3V-862.618H0Z","transform":"translate(0 862.618)","fill":"#9a9cc9"}));
}

Lightbluebox.defaultProps = {"viewBox":"0 0 480 480"};

module.exports = Lightbluebox;

Lightbluebox.default = Lightbluebox;
